var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedoButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0712 3.55489C7.67973 2.17418 4.62178 2.99356 3.24106 5.38502C1.86035 7.77649 2.67973 10.8344 5.07119 12.2151C7.46266 13.5959 10.5206 12.7765 11.9013 10.385C12.274 9.73946 12.4861 9.04661 12.5507 8.35163C12.5763 8.07668 12.8199 7.87451 13.0949 7.90009C13.3698 7.92566 13.572 8.16929 13.5464 8.44425C13.4687 9.27987 13.2136 10.1121 12.7673 10.885C11.1105 13.7548 7.44095 14.738 4.57119 13.0812C1.70144 11.4243 0.718185 7.75478 2.37504 4.88502C4.03189 2.01527 7.70144 1.03202 10.5712 2.68887L10.0712 3.55489Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33807 4.8247L11.3043 1.41907C11.4103 1.23551 11.6823 1.25884 11.7554 1.45777L12.8157 4.34032C12.8696 4.48685 12.7775 4.64639 12.6237 4.67297L9.59715 5.19604C9.38829 5.23214 9.23209 5.00826 9.33807 4.8247Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedoButton);
export default __webpack_public_path__ + "static/media/redoButton.442cfc95254d2eb61f11a519873e069d.svg";
export { ForwardRef as ReactComponent };